const videos = {
    portugues: {
      title: 'Lives',
      subTitle: 'Conheça as mais belas gatas do Bella da Semana. Confira abaixo as últimas modelos:',
      placeHolderSelect: 'Filtrar por nome',
      SeeAllModels: 'Veja todas modelos:',
      labelPagination: 'de',
      shootModel: 'Veja a live',
      featuredModels: 'Modelos em destaque:',
      lastModels: 'Últimas Modelos',
      models: 'Modelos'
    },
    ingles: {
      title: 'Lives',
      subTitle: 'Meet the most beautiful Bella Club babes. Check out the latest models below:',
      placeHolderSelect: 'Filter by name',
      SeeAllModels: 'See all models:',
      labelPagination: 'of',
      shootModel: 'See the live',
      featuredModels: 'Featured Models:',
      lastModels: 'Last Models',
      models: 'Models'
    }
  }
  
  export default videos
  